/*
 * @Author: hzk
 * @Date: 2021-01-18 16:15:11
 * @LastEditors: hzk
 * @LastEditTime: 2021-01-18 18:05:49
 */
import Seal from './seal.vue';

export default Seal;